var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmpty(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 251,
    height: 282,
    viewBox: "0 0 251 282",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 222,
    height: 268,
    rx: 2.5,
    fill: "#F5F9FD",
    stroke: "#DCDFE2"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 15,
    width: 187,
    height: 69,
    fill: "#E9EBED"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 33,
    width: 134,
    height: 13,
    fill: "#D3D9DF"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 54,
    width: 111,
    height: 13,
    fill: "#D3D9DF"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 96,
    width: 187,
    height: 69,
    fill: "#E9EBED"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 114,
    width: 134,
    height: 13,
    fill: "#D3D9DF"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 135,
    width: 111,
    height: 13,
    fill: "#D3D9DF"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 177,
    width: 187,
    height: 69,
    fill: "#E9EBED"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 195,
    width: 134,
    height: 13,
    fill: "#D3D9DF"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 216,
    width: 111,
    height: 13,
    fill: "#D3D9DF"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 216.5,
    cy: 247.5,
    r: 34.5,
    fill: "#EA2027"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M215.5 252.5H218.5V255.5H215.5V252.5ZM215.5 240.5H218.5V249.5H215.5V240.5ZM216.985 233C208.705 233 202 239.72 202 248C202 256.28 208.705 263 216.985 263C225.28 263 232 256.28 232 248C232 239.72 225.28 233 216.985 233ZM217 260C210.37 260 205 254.63 205 248C205 241.37 210.37 236 217 236C223.63 236 229 241.37 229 248C229 254.63 223.63 260 217 260Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmpty);
export default __webpack_public_path__ + "static/media/empty.3028d6f03c6691a3f19835f0a6f268b0.svg";
export { ForwardRef as ReactComponent };